import { z } from 'zod'

/**
 * The groups screen's URL search params.
 *
 * The status filter and the name search live in the URL so a filtered view is
 * linkable and survives a reload (AGENTS.md). Zod validates at the boundary
 * with the route; the inferred type flows into the screen.
 */
export const GROUP_STATUSES = ['active', 'suspended', 'pending_purge', 'purged'] as const

export const groupsSearchSchema = z.object({
  status: z.enum(GROUP_STATUSES).optional(),
  q: z.string().optional(),
})

export type GroupsSearch = z.infer<typeof groupsSearchSchema>
export type GroupStatus = (typeof GROUP_STATUSES)[number]
